import React, { useEffect, useRef, useState } from "react";
// import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  filterBy,
  CompositeFilterDescriptor,
} from "@progress/kendo-data-query";
import {
  Grid as KendoGrid,
  GridColumn as Column,
  //   GridCellProps,
  GridFilterChangeEvent,
  GridPageChangeEvent,
  GridCustomHeaderCellProps,
  GridCustomCellProps,
} from "@progress/kendo-react-grid";
import {
  Avatar,
  GridLayout,
  GridLayoutItem,
} from "@progress/kendo-react-layout";
import { HeaderThElement } from "@progress/kendo-react-data-tools";
import { Typography } from "@progress/kendo-react-common";
// import { Button } from "@progress/kendo-react-buttons";
// import { FiEdit } from "react-icons/fi";
// import { Switch } from "@progress/kendo-react-inputs";
// import AlertBox from "../../components/common/AlertBox";
import { LoadingPanel } from "../../components/layout/Loading";
// import IconButton from "../../components/common/IconButton";
// import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { closeDialog } from "../../components/dialog/dialogSlice";
// import { MdDelete } from "react-icons/md";

// import { checkAcessRights } from "../../_helper/helper";
import //   DELETE_ACCESS,
//   EDIT_ACCESS,
//   INSERT_ACCESS,
"../../_contstants/common";
import _debounce from "lodash/debounce";
import { getAllContact } from "./services/contact.services";
import { setCurrentPage, setPageLimit } from "../pagination/paginationSlice";
import { setFilterContact } from "./contactSlice";
import { TextBox } from "@progress/kendo-react-inputs";
import { Button } from "@progress/kendo-react-buttons";
import { filterClearIcon } from "@progress/kendo-svg-icons";
import moment from "moment";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import { checkAcessRights } from "../../_helper/helper";
import { EXCEL_EXPORT_ACCESS } from "../../_contstants/common";

const Contact: React.FC = () => {
  const dispatch = useAppDispatch();
  //   const navigate = useNavigate();
  //   const isAddAccess = checkAcessRights(location.pathname, INSERT_ACCESS);
  const isExcelAccess = checkAcessRights(
    location.pathname,
    EXCEL_EXPORT_ACCESS
  );
  useEffect(() => {
    return () => {
      dispatch(closeDialog());
    };
  }, []);

  //   const handleCreate = () => {
  //     navigate("/contact/create");
  //   };
  const handleExportExcel = () => {
    const table = document.querySelector(
      ".contact-excel-export"
    ) as HTMLTableElement;
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.table_to_sheet(table);

    // Adjust column widths dynamically
    const colWidths: number[] = [];
    const rows = table.querySelectorAll("tr");

    rows.forEach((row) => {
      const cells = row.querySelectorAll("th, td");
      cells.forEach((cell, colIndex) => {
        const cellContent = cell.textContent || "";
        const cellLength = cellContent.length;

        // Calculate width (max of existing or current cell)
        colWidths[colIndex] = Math.max(
          colWidths[colIndex] || 10,
          cellLength + 2
        );
      });
    });
    // Apply column widths
    ws["!cols"] = colWidths.map((width) => ({ wch: width }));

    Object.keys(ws).forEach((key) => {
      if (!key.startsWith("!")) {
        const cell = ws[key];
        if (cell.z !== "m/d/yy") {
          if (typeof cell.v === "number") {
            // Check if the cell is a date (custom logic depending on your use case)
            const isDate = cell.t === "d"; // 't' might indicate the cell type in some libraries
            if (!isDate) {
              cell.t = "s"; // Set cell type to 'string'
              cell.v = `${cell.v}`; // Convert number to string
            }
          }
        } else if (cell.z === "m/d/yy") {
          cell.z = "DD-MMM-YYYY";
        }
      }
    });

    XLSX.utils.book_append_sheet(wb, ws, `Contact`);

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(data, `Contact`);
  };

  return (
    <>
      {/* <DeleteContactDialog /> */}
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 0 20px 0",
          }}
        >
          <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
            Inquiry List
          </Typography.h4>
          {isExcelAccess && (
            <Button
              style={{ marginRight: 5 }}
              type="button"
              fillMode={"solid"}
              themeColor={"primary"}
              onClick={handleExportExcel}
            >
              Excel Export
            </Button>
          )}
          {/* {isAddAccess && (
            <Button
              onClick={handleCreate}
              fillMode={"solid"}
              themeColor={"primary"}
            >
              {"Create Seo Tag"}
            </Button>
          )} */}
        </GridLayoutItem>
        <GridLayoutItem>
          <ContactGridComponent />
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

const ContactGridComponent: React.FC = () => {
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  //   const navigate = useNavigate();
  //   const isEditAccess = checkAcessRights(location.pathname, EDIT_ACCESS);
  //   const isDeleteAccess = checkAcessRights(location.pathname, DELETE_ACCESS);
  const ContactList = useAppSelector((state) => state.contact.ContactList);
  const loading = useAppSelector((state) => state.contact.loading);
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  const FilterContact: any = useAppSelector(
    (state) => state.contact.FilterContact
  );

  // const [expandedRow, setExpandedRow] = useState(null);
  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);

  useEffect(() => {
    const payload = {
      ...FilterContact,
      Limit: +pageLimit,
      Skip: +currentPage * +pageLimit,
    };
    dispatch(getAllContact(payload));
  }, [currentPage, pageLimit]);

  const pageChange = (event: GridPageChangeEvent) => {
    const newPage = event.page.skip / event.page.take;
    dispatch(setPageLimit(event.page.take));
    dispatch(setCurrentPage(newPage));
  };

  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
  };
  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className={`table-header ${
        props.index === 3 || props.index === 4 ? "locked-header" : ""
      }`}
    >
      {props.children}
    </HeaderThElement>
  );

  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };

  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <KendoGrid
        style={{ maxHeight: "calc(100vh - 152px)" }}
        filterable={true}
        className="table-bordered responsive-table contact-excel-export"
        filter={filter}
        data={filter ? filterBy(ContactList, filter) : ContactList}
        onFilterChange={handleFilterChange}
        total={ContactList[0]?.ItemCount || ContactList.length}
        skip={currentPage * pageLimit}
        take={pageLimit}
        pageable={{
          buttonCount: 5,
          pageSizes: [10, 50, 100, 300, 500],
          pageSizeValue: pageLimit,
          type: "input",
        }}
        onPageChange={pageChange}
        cells={{
          headerCell: HeaderCustomCell,
          data: MyDataCustomCell,
        }}
      >
        <Column
          field="Date"
          title="Date"
          cell={(props) => (
            <td>
              {props.dataItem.Date
                ? moment(props.dataItem.Date, "DD/MM/YYYY").format(
                    "DD-MMM-YYYY"
                  )
                : ""}
            </td>
          )}
          width={150}
        />
        <Column
          field="FirstName"
          title="Name"
          width={200}
          cell={(props) => (
            <td>{`${props.dataItem.FirstName} ${props.dataItem.LastName}`}</td>
          )}
          filterCell={CommonFilterCell}
        />

        <Column field="BusinessName" title="Business Name" width={200} />
        <Column
          field="Email"
          title="Email"
          filterCell={CommonFilterCell}
          width={300}
        />
        <Column field="PhoneNo" title="Phone No" width={200} />
        <Column field="Remarks" title="Remarks" width={200} />
        <Column field="TypeOfBusiness" title="Type Of Business" width={200} />
        <Column
          field="AvgMonthlyTransactions"
          title="Avg Monthly Transactions"
          width={220}
        />

        <Column
          field="Document"
          title="Document"
          filterable={false}
          width={150}
          cell={(props: any) => (
            <td>
              {props.dataItem?.Document && (
                <Avatar
                  style={{
                    width: 45,
                    height: 45,
                    flexBasis: 45,
                  }}
                  rounded={"full"}
                  type={"image"}
                >
                  <img
                    src={props.dataItem?.Document}
                    alt="Document"
                    onClick={() =>
                      props.dataItem?.Document &&
                      window.open(props.dataItem?.Document)
                    }
                    width={200}
                    height={200}
                  />
                </Avatar>
              )}
            </td>
          )}
        />
      </KendoGrid>
    </>
  );
};

const CommonFilterCell = (props: any) => {
  const dispatch = useAppDispatch();
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  const FilterContact: any = useAppSelector(
    (state) => state.contact.FilterContact
  );
  const isFilterRef = useRef(true);
  const [inputValue, setInputValue] = useState(props.value || "");
  const [inputField, setInputField] = useState(props.field || "");

  const onChange = (event: any) => {
    setInputValue(event.target.value);
    setInputField(event.target.name);
  };

  const delayedApiCall = React.useCallback(
    _debounce((updatedFilters: any) => {
      dispatch(setCurrentPage(0));
      const payload = {
        ...updatedFilters,
        Limit: +pageLimit,
        Skip: 0 * +pageLimit,
      };

      dispatch(getAllContact(payload));
    }, 300),
    [dispatch]
  );

  useEffect(() => {
    if (!isFilterRef.current) {
      const updatedFilters = {
        ...FilterContact,
        [inputField]: inputValue,
      };
      dispatch(setFilterContact(updatedFilters));
      delayedApiCall(updatedFilters);
    } else {
      isFilterRef.current = false;
    }
    return () => {
      delayedApiCall.cancel();
    };
  }, [inputValue, delayedApiCall]);

  const onClearButtonClick = (event: any) => {
    event.preventDefault();
    props.onChange({
      value: null,
      operator: "",
      syntheticEvent: event,
    });

    const updatedFilters = { ...FilterContact, [props.field]: "" };
    dispatch(setFilterContact(updatedFilters));

    const payload = {
      ...updatedFilters,

      Limit: +pageLimit,
      Skip: +currentPage * +pageLimit,
    };

    dispatch(getAllContact(payload));
  };

  return (
    <div className="d-flex">
      <TextBox
        value={FilterContact[props.field] || ""}
        name={props.field || ""}
        onChange={onChange}
      />
      <Button
        svgIcon={filterClearIcon}
        title="Clear"
        disabled={!FilterContact[props.field]}
        onClick={onClearButtonClick}
        type="button"
        style={{
          marginLeft: "8px",
        }}
      ></Button>
    </div>
  );
};

export default Contact;
